/**
 * Карты соревновательных мероприятий.
 *
 * Списки закреплены в коде, а не в настройках: их задаёт лига, а не
 * сообщество, и каждой карте соответствует картинка в `server/assets/maps`.
 * Настройка, где можно завести карту без картинки, обещала бы больше, чем
 * бот умеет.
 *
 * Названия и файлы взяты с самих картинок: на них подписано `Windmill`, а
 * не `windwill`, и `Industrial`, а не `industrial area`.
 */

export interface CompetitiveMap {
  /** Ключ в базе: не меняется, даже если подпись однажды перепишут. */
  id: string;
  label: string;
  /** Имя файла в `server/assets/maps`. */
  file: string;
}

const MCL_MAPS: readonly CompetitiveMap[] = [
  { id: 'ghetto', label: 'Ghetto', file: 'ghetto.jpg' },
  { id: 'industrial', label: 'Industrial', file: 'industrial.jpg' },
  { id: 'vinewood', label: 'Vinewood', file: 'vinewood.jpg' },
  { id: 'sandy-shores', label: 'Sandy Shores', file: 'sandy-shores.jpg' },
  { id: 'farm', label: 'Farm', file: 'farm.jpg' },
  { id: 'city', label: 'City', file: 'city.jpg' },
  { id: 'mirror', label: 'Mirror', file: 'mirror.jpg' },
];

const VZZ_MAPS: readonly CompetitiveMap[] = [
  { id: 'windmill', label: 'Windmill', file: 'windmill.jpg' },
  { id: 'redwood', label: 'Redwood', file: 'redwood.jpg' },
  { id: 'vineyards', label: 'Vineyards', file: 'vineyards.jpg' },
];

/**
 * Карты по типу мероприятия.
 *
 * Ключ — название типа так, как его пишет сообщество. Типы настраиваются,
 * поэтому сравнение идёт без учёта регистра и лишних пробелов: `mcl` и
 * `MCL ` — один и тот же тип.
 */
const MAPS_BY_TYPE = new Map<string, readonly CompetitiveMap[]>([
  ['mcl', MCL_MAPS],
  ['vzz', VZZ_MAPS],
]);

/** Карты этого типа мероприятия. Пустой список — карта не нужна. */
export function mapsForEventType(eventType: string): readonly CompetitiveMap[] {
  return MAPS_BY_TYPE.get(eventType.trim().toLocaleLowerCase()) ?? [];
}

/** Нужна ли этому типу карта: у капта карт нет, у MCL и VZZ есть. */
export function eventTypeNeedsMap(eventType: string): boolean {
  return mapsForEventType(eventType).length > 0;
}

/** Карта по ключу — только из списка своего типа. */
export function findMap(eventType: string, mapId: string | null): CompetitiveMap | null {
  if (mapId === null) {
    return null;
  }

  return mapsForEventType(eventType).find((map) => map.id === mapId) ?? null;
}
